import { ScheduledTask } from './ScheduledTask';
import { RuntimeSchedule } from './RuntimeSchedule';
import { bound } from '../../../../utils/decorators/basic';

export class RuntimeScheduleNextState extends RuntimeSchedule {
  latestRun;

  async addToNext(actionFunc: Function, options: Partial<ScheduledTask> = {}): Promise<any> {
    const task = this.addTask(actionFunc, options);
    if (!task) return;

    this.triggerNextStateChange();

    return await task.promise;
  }

  nextTimer: number | undefined;

  @bound
  triggerNextStateChange() {
    if (typeof this.nextTimer === 'undefined') {
      this.nextTimer = setTimeout(this.processNextStateChange, 20) as any;
    }
  }

  @bound
  processNextStateChange() {
    this.nextTimer = undefined;
    return super.processCurrentBatch();
  }
}
